import { z } from 'zod';

export const AuditAction = z.enum([
  'create',
  'update',
  'delete',
  'status_change',
  'bulk_action',
  'image_change',
  'lookup_change',
  'csv_import',
  // Google Sheet mirror: written on a backfill/rebuild, and on a failed
  // per-change sync so drift shows up in the audit log.
  'sheet_sync',
]);
export type AuditAction = z.infer<typeof AuditAction>;

export const AuditEntity = z.enum([
  'inventory',
  'part',
  'product',
  'brand',
  'inventory_type',
  'tag',
  'part_category',
  'product_category',
  'system',
]);
export type AuditEntity = z.infer<typeof AuditEntity>;

export const AuditEntry = z.object({
  id: z.number().int().positive(),
  actor_email: z.string().email().nullable(),
  action: AuditAction,
  entity: AuditEntity,
  entity_id: z.number().int().nullable(),
  diff: z.unknown().nullable(),
  at: z.string().datetime(),
});
export type AuditEntry = z.infer<typeof AuditEntry>;
